import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

// Copyright 1999-2020. Plesk International GmbH. All rights reserved.
import React, { isValidElement, Children } from 'react';
import classNames from 'classnames';
import { CLS_PREFIX } from '../../constants';
import { wrapFunction } from '../utils';
import Icon, { ICON_SIZE_16 } from '../Icon';
import Spinner from '../Spinner';

/**
 * `Action` component is used mostly for navigation, to go between pages, and not for immediate action or submitting data.
 * @since 0.0.68
 */
var Action = function Action(_ref) {
  var _classNames;

  var _ref$baseClassName = _ref.baseClassName,
      baseClassName = _ref$baseClassName === void 0 ? "".concat(CLS_PREFIX, "action") : _ref$baseClassName,
      _ref$component = _ref.component,
      Tag = _ref$component === void 0 ? 'a' : _ref$component,
      icon = _ref.icon,
      rightAddon = _ref.rightAddon,
      bottomAddon = _ref.bottomAddon,
      children = _ref.children,
      _ref$progress = _ref.progress,
      progress = _ref$progress === void 0 ? false : _ref$progress,
      _ref$nowrap = _ref.nowrap,
      nowrap = _ref$nowrap === void 0 ? false : _ref$nowrap,
      _ref$outerProps = _ref.outerProps,
      outerProps = _ref$outerProps === void 0 ? {} : _ref$outerProps,
      props = _objectWithoutProperties(_ref, ["baseClassName", "component", "icon", "rightAddon", "bottomAddon", "children", "progress", "nowrap", "outerProps"]);

  var className = outerProps.className,
      restOuterProps = _objectWithoutProperties(outerProps, ["className"]);

  icon = Icon.create(icon, {
    className: "".concat(baseClassName, "__icon"),
    size: ICON_SIZE_16
  });
  var size = ICON_SIZE_16;

  if (isValidElement(icon) && icon.props.size) {
    size = icon.props.size;
  }

  if (progress) {
    icon = React.createElement(Icon, {
      size: size,
      className: "".concat(baseClassName, "__icon")
    }, React.createElement(Spinner, null));
  }

  var tagProps = _objectSpread({}, props, {
    className: classNames(props.className, "".concat(baseClassName, "__content")) || undefined
  });

  if (tagProps.onClick) {
    tagProps.tabIndex = tagProps.tabIndex || 0;
    tagProps.onKeyDown = wrapFunction(tagProps.onKeyDown, function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        e.currentTarget.click();
      }
    });
  }

  return React.createElement("div", _extends({
    className: classNames(baseClassName, (_classNames = {}, _defineProperty(_classNames, "".concat(baseClassName, "--size-").concat(size), icon || progress), _defineProperty(_classNames, "".concat(baseClassName, "--progress"), progress), _defineProperty(_classNames, "".concat(baseClassName, "--nowrap"), nowrap), _defineProperty(_classNames, "".concat(baseClassName, "--icon"), !Children.toArray(children).length && !rightAddon && !bottomAddon), _classNames), className)
  }, restOuterProps), React.createElement(Tag, tagProps, icon, children), rightAddon ? React.createElement("div", {
    className: "".concat(baseClassName, "__right-addon")
  }, rightAddon) : null, bottomAddon ? React.createElement("div", {
    className: "".concat(baseClassName, "__bottom-addon")
  }, bottomAddon) : null);
};

export default Action;